import Immutable from 'immutable'
import { createSelector } from 'reselect'

import { getBasketRecipes } from 'selectors/basket'
import { getAvailableRecipes } from 'selectors/menu-recipes/getAvailableRecipes'

export const getOkRecipeIds = (state) => {
  const availableRecipes = getAvailableRecipes(state)

  const basketRecipes = getBasketRecipes(state)
  const basketRecipeAmounts = basketRecipes.toJS()
  const basketRecipeDetails = Object.entries(basketRecipeAmounts).map(([uuid, amount]) => ({
    uuid,
    amount,
  }))

  return Immutable.fromJS(
    Object.fromEntries(
      basketRecipeDetails
        .filter(({ uuid }) => uuid && uuid in availableRecipes)
        .map(({ uuid, amount }) => [uuid, amount]),
    ),
  )
}

export const getUnavailableRecipeIds = createSelector(
  getBasketRecipes,
  getOkRecipeIds,
  (basketRecipes, okRecipeIds) =>
    basketRecipes.filter((obj, recipeId) => !okRecipeIds.has(recipeId)),
)

export const getShowBasketTooltip = ({ tutorial }) =>
  Boolean(tutorial && tutorial.getIn(['viewed', 'basket-tooltip']))

export const getHasSeenFlexEducationTooltip = ({ tutorial }) =>
  Boolean(tutorial && tutorial.getIn(['viewed', 'flex-education-tooltip']))
